import classnames from "classnames";
import React from "react";
import colours from "styles/colours";

import {
  SwitchContainer,
  SwitchInput,
  SwitchLabel,
  SwitchSlider,
  SwitchToggleLabel,
} from "./style";

interface Props {
  name: string;
  onColor: string | null;
  offColor?: string;
  onClick: () => void;
  switchedOn: boolean;
  leftLabel: string;
  rightLabel?: string;
  headerLabel?: boolean;
  disabled?: boolean;
}

interface SwitchComponentProps {
  name: string;
  switchedOn: boolean;
  onClick: () => void;
  disabled?: boolean;
  leftLabel: string;
  onColor: string | null;
  offColor?: string;
}

const isActivationKey = (key: string): boolean => key === "Enter";

const SwitchComponent: React.FC<SwitchComponentProps> = ({
  name,
  switchedOn,
  onClick,
  disabled,
  leftLabel,
  onColor,
  offColor,
}) => (
  <SwitchToggleLabel htmlFor={`${name}--switch`}>
    <SwitchInput
      id={`${name}--switch`}
      type="checkbox"
      checked={switchedOn}
      onClick={onClick}
      onKeyDown={(event): void => {
        if (disabled) return;
        if (!isActivationKey(event.key)) return;
        event.preventDefault();
        onClick();
      }}
      readOnly
      disabled={disabled}
      aria-label={leftLabel}
      aria-checked={switchedOn}
    />
    <SwitchSlider
      $colour={(switchedOn ? onColor : offColor) || colours.mediumLightGrey}
    />
  </SwitchToggleLabel>
);

const Switch: React.FC<Props> = ({
  name,
  onColor,
  offColor,
  onClick,
  switchedOn,
  leftLabel,
  rightLabel,
  headerLabel = false,
  disabled,
}: Props) => (
  <SwitchContainer className={classnames({ reverse: headerLabel })}>
    {rightLabel && (
      <SwitchLabel className={classnames({ header: headerLabel })}>
        {rightLabel}
      </SwitchLabel>
    )}
    <SwitchComponent
      name={name}
      switchedOn={switchedOn}
      onClick={onClick}
      disabled={disabled}
      leftLabel={leftLabel}
      onColor={onColor}
      offColor={offColor}
    />
    <SwitchLabel className={classnames({ header: headerLabel })}>
      {leftLabel}
    </SwitchLabel>
  </SwitchContainer>
);

export default Switch;
